import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { services } from '../../context';
import { StoresState } from './storesTypes';

const initialState: StoresState = {
  availableStores: [],
  replacementServiceStores: [],
};

export const getStores = createAsyncThunk(
  'stores/getStores',
  async (
    {
      zipCode,
      serviceProductId,
      isReplacementServiceStore,
    }: {
      zipCode: string;
      serviceProductId: string;
      isReplacementServiceStore?: boolean;
    },
    { rejectWithValue },
  ) => {
    const { result, error } = await services.appointment.getAvailableStores(
      zipCode,
      serviceProductId,
    );

    if (error) {
      return rejectWithValue(error);
    }

    return { stores: result.stores, isReplacementServiceStore };
  },
);

const storesSlice = createSlice({
  name: 'stores',
  initialState,
  reducers: {
    clearAvailableStores(state) {
      state.availableStores = [];
      state.replacementServiceStores = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getStores.fulfilled, (state, action) => {
      if (action.payload.isReplacementServiceStore) {
        state.replacementServiceStores = action.payload.stores;
      } else {
        state.availableStores = action.payload.stores;
      }
    });
  },
});

export const { clearAvailableStores } = storesSlice.actions;

export default storesSlice.reducer;
